import {
  fetchDevicesData,
  removeDeviceOwnership,
  sendBatchRequest,
  fetchShareUserDevice,
  pushShareUserDevice,
  removeShareUserDevice,
  fetchShareUserDeviceList,
} from '@/api/api.APP_TARGET';
import Logger from '@/js/logger';

const getMyDeviceData = ({ state, commit }) => {
  if (state.promise) return state.promise;
  const fetchPromise = fetchDevicesData().then((deviceData) => {
    commit('SET_DEVICE_DATA', deviceData);
  });
  commit('SET_PROMISE', fetchPromise);
  return fetchPromise;
};

const getSharedDeviceData = ({ state, commit }) => {
  if (state.sharedDevicePromise) return state.sharedDevicePromise;
  const fetchPromise = fetchShareUserDeviceList().then((deviceData) => {
    commit('SET_SHARED_DEVICE_LIST', deviceData);
  });
  commit('SET_SHARED_DEVICE_PROMISE', fetchPromise);
  return fetchPromise;
};

const clearSharedDeviceData = ({ commit }) => {
  commit('SET_SHARED_DEVICE_PROMISE', null);
};

const setSharedDeviceData = ({ commit }, payload) => {
  commit('SET_SHARED_DEVICE_LIST', payload);
};

const updateSharedDeviceData = ({ commit }, payload) => {
  commit('UPDATE_SHARED_DEVICE_LIST', payload);
};

const clearDeviceData = ({ commit }) => {
  commit('SET_PROMISE', null);
};

const setDeviceData = ({ commit }, payload) => {
  commit('SET_DEVICE_DATA', payload);
};

const updateDeviceData = ({ commit }, payload) => {
  commit('UPDATE_DEVICE_DATA', payload);
};

const deregisterDevice = ({ commit }, payload) => {
  return removeDeviceOwnership(payload.dev_id);
};

const getSharedUserData = ({ commit }, { dev_id }) => {
  return fetchShareUserDevice(dev_id).then((u) => {
    const body = typeof u === 'string' ? JSON.parse(u) : u;
    commit('SET_SHARE_DEVICE', { dev_id, body });
  });
};

const getBatchShareDevice = ({ commit }, deviceList) => {
  if (!deviceList.length) return;
  const requests = deviceList.map((device) => ({
    ...fetchShareUserDevice(device.dev_id, true),
    dev_id: device.dev_id,
    commit: 'SET_SHARE_DEVICE',
  }));
  return sendBatchRequest(
    requests.map((el) => ({
      method: el.method,
      relative_url: el.relative_url,
      body: el.body,
    }))
  ).then((res) => {
    if (!Array.isArray(res)) {
      throw new Error(
        res && res.message ? res.message : 'INVALID_BATCH_RESPONSE'
      );
    }
    res.forEach((r) => {
      const req = requests.find(
        (request) => request.relative_url === r.relative_url
      );
      if (!req) return;
      const response = Object.assign({}, req, r);
      if (response?.passcode?.indexOf(response.status) !== -1) {
        Logger.info('[HTTP Batch res]', response);
        const body =
          typeof response.body === 'string'
            ? JSON.parse(response.body)
            : response.body;
        commit(response.commit, {
          dev_id: response.dev_id,
          body,
        });
      }
    });
  });
};

const addShareUserDevice = ({ commit }, { dev_id, data }) => {
  return pushShareUserDevice(dev_id, data).then((u) =>
    commit('SET_SHARE_USER_DEVICE', { dev_id, body: u })
  );
};

const deleteShareUserDevice = ({ commit }, { dev_id, share_id }) => {
  return removeShareUserDevice(share_id).then(() =>
    commit('REMOVE_SHARE_USER_DEVICE', { dev_id, share_id })
  );
};

const deleteShareDevice = ({ commit }, { dev_id, share_id }) => {
  return removeShareUserDevice(share_id).then(() =>
    commit('REMOVE_SHARE_DEVICE', { dev_id })
  );
};

export default {
  getMyDeviceData,
  setDeviceData,
  clearDeviceData,
  updateDeviceData,
  getSharedDeviceData,
  setSharedDeviceData,
  clearSharedDeviceData,
  updateSharedDeviceData,
  deregisterDevice,
  getBatchShareDevice,
  addShareUserDevice,
  deleteShareUserDevice,
  deleteShareDevice,
  getSharedUserData,
};
